import { ROLES } from 'app/config/role-permission'
import { User } from 'types/User'

export const permission = {
  canChangeSpecificationFile(currentUser: User | null) {
    return currentUser && [ROLES.admin].includes(currentUser.permission)
  },
  canAccessPharmacyDataUpdate(currentUser: User | null) {
    return currentUser && [ROLES.doctor].includes(currentUser.permission)
  },
}
